export default class SpaceFillingCurve {
    tileExtent;
    _numBits;
    _coordinateShift;
    minBound;
    maxBound;
    constructor(minVertexValue, maxVertexValue) {
        // TODO: fix tile buffer problem
        this._coordinateShift = minVertexValue < 0 ? Math.abs(minVertexValue) : 0;
        this.tileExtent = maxVertexValue + this._coordinateShift;
        this._numBits = Math.ceil(Math.log2(this.tileExtent));
        this.minBound = minVertexValue;
        this.maxBound = maxVertexValue;
    }
    validateCoordinates(vertex) {
        // TODO: also check for int overflow as we are limiting the sfc ids to max int size
        if (vertex.x < this.minBound ||
            vertex.y < this.minBound ||
            vertex.x > this.maxBound ||
            vertex.y > this.maxBound) {
            throw new Error("The specified tile buffer size is currently not supported.");
        }
    }
    numBits() {
        return this._numBits;
    }
    coordinateShift() {
        return this._coordinateShift;
    }
}
//# sourceMappingURL=spaceFillingCurve.js.map